
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })

    pageData.columns = [
      {
        title: '变动日期',
        dataIndex: 'EnddateD',
        key: 'EnddateD',
        width: '100px'
      },
      {
        title: '名次',
        dataIndex: 'Rank',
        key: 'Rank',
        width: '50px'
      },
      {
        title: '股东名称',
        dataIndex: 'SHName',
        key: 'SHName',
        width: '100px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '股份类型',
        dataIndex: 'ShareType',
        key: 'ShareType',
        width: '90px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '持股数(股)',
        dataIndex: 'HoldSum',
        key: 'HoldSum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总股本比例',
        dataIndex: 'PCTOfFloatShares',
        key: 'PCTOfFloatShares',
        width: '120px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '变动股数(股)',
        dataIndex: 'IncreaseOrReduce',
        key: 'IncreaseOrReduce',
        width: '115px',
        ellipsis: true,
        slots: { customRender: 'peopleCountColor' }
      },
      {
        title: '增减股占原股东持股比例',
        dataIndex: 'ChangeRatio',
        key: 'ChangeRatio',
        width: '180px',
        slots: { customRender: 'increase' }
      },
      {
        title: '变动原因',
        dataIndex: 'ChangeReason',
        key: 'ChangeReason',
        // width: "90px",
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      }
    ]

    watch(
      () => (props.pageSourceData || {}).TopTenSHHoldChange || [],
      () => {
        const _data = (props.pageSourceData || {}).TopTenSHHoldChange || []
        let list = []
        if (_data.length) {
          list = JSON.parse(JSON.stringify(_data))
          list.forEach((item: any, i: number) => {
            item.index = 'TopTenSHHoldChange' + i
            item.EnddateD = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
        }
        nextTick(() => {
          pageData.spinning = false
        })
        pageData.data = list
      },
      { deep: true }
    )

    return {
      ...toRefs(pageData)
    }
  }
})
